import type { ContentTag } from '@/types';
import classNames from 'classnames';
import type { CSSProperties } from 'react';
import * as styles from '../Post.css';

interface Props {
  className?: string;
  tags: ContentTag[];
  postCategory?: string | null;
  tagStyle?: CSSProperties & {
    badgeEnabled?: boolean;
    textAlign: 'left' | 'center' | 'right' | undefined;
  };
}

const ALIGN_OPTIONS = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

const Tags = ({ tags, tagStyle, className, postCategory }: Props) => {
  // We discussed and only want to show the first tag, at least for now
  if (!tags || tags.length === 0) return null;
  let firstTag = tags[0];

  // If there is a post category, we want to show the tag that matches the post category
  if (postCategory) {
    firstTag = { id: 'post-category', display: postCategory } as ContentTag;
  }

  return (
    <div className={classNames('flex', ALIGN_OPTIONS[tagStyle?.textAlign || 'left'])}>
      <span
        className={classNames(
          'whitespace-nowrap text-xs w-fit',
          tagStyle?.badgeEnabled ? 'px-2 py-1' : '',
          'rounded-[var(--tag-border-radius)]',
          styles.postCardTags,
          className,
        )}
      >
        {firstTag.display}
      </span>
    </div>
  );
};

export default Tags;
